<div class="container mt-5">
  <div class="table-container">
    <div class="title">
      <h2>{{ title }}</h2>
      <div class="search-filter">
        <app-search (enterEvent)="search($event)"></app-search>
        <div *ngIf="filter" class="icon-filter">
          <ion-button color="secondary" (click)="open()"
            ><ion-icon name="filter-circle-outline"></ion-icon
            >Filtros</ion-button
          >
        </div>
      </div>
    </div>
    <div class="table-responsive">
      <table class="table table-striped">
        <thead class="thead-header">
          <tr>
            <th scope="col" class="title-table" *ngFor="let column of columns">
              {{ column.texto }}
            </th>
          </tr>
        </thead>
        <tbody>
          <tr *ngFor="let row of data | paginate: { itemsPerPage: 10, currentPage: page }">
            <td *ngFor="let column of columns">
              <ng-container *ngIf="column.key === 'state'; else regularDataTemplate">
                <select [(ngModel)]="row[column.key]" [disabled]="row[column.key] === 'INFORMED' || row[column.key] === 'IMPLEMENTED'" (ngModelChange)="changeState(row['id'])">
                  <option value="PENDING" [disabled]="row[column.key] === 'INFORMED' || row[column.key] === 'IMPLEMENTED'">PENDING</option>
                  <option value="IMPLEMENTED" [disabled]="row[column.key] == 'IMPLEMENTED'" >IMPLEMENTED</option>
                  <option value="INFORMED" [disabled]="true">INFORMED</option>
                </select>
              </ng-container>
      
              <ng-template #regularDataTemplate>
                <ng-container *ngIf="column.key !== 'alertTypeIcon' && column.key !== 'alert_type_name' && column.key !== 'executor'; else iconAndNameTemplate">
                  <ng-container *ngIf="column.key !== 'date'; else formatDateTemplate">
                    {{ row[column.key] }}
                  </ng-container>
                </ng-container>
                <ng-template #formatDateTemplate>
                  {{ row["date"] | date : "medium" }}
                </ng-template>
      
                <ng-template #iconAndNameTemplate>
                  <div class="icon-and-name">
                    <div>
                      <img
                      slot="end"
                      *ngIf="column.key ==  'executor' "
                      src="{{row['executor_type'] === 'USER' ? './assets/img/logo-iguana-portal-izquierda.png' : './assets/img/robot-svgrepo-com.svg'}} "
                      alt="Imagen"
                      width="30"
                      height="30"
                      class="alert-type-icon"
                    />
                    <img 
                    slot="end"
                    *ngIf="column.key !=  'executor'"
                    src="{{row['alertTypeIcon']}}"
                    alt="Imagen"
                    width="30"
                    height="30"
                    class="alert-type-icon"
                  />
                    <span slot="start" class="alert-type-name">{{
                     row[column.key]
                    }}</span>
                  </div>
                </div>
                </ng-template>
                <ion-icon
                  (click)="navigateRute(row)"
                  class="ruta"
                  *ngIf="column.key === 'ruta'"
                  name="open-outline"
                ></ion-icon>
              </ng-template>
            </td>
          </tr>
        </tbody>
      </table>
      <div style="text-align: center;" *ngIf="data.length <=0">No hay datos disponibles</div>
    </div>
    
    

    <pagination-controls
      class="my-pagination"
      (pageChange)="page = $event"
      previousLabel=""
      nextLabel=""
      >></pagination-controls
    >
  </div>
  <div class="container-popover popover-custom-animation" *ngIf="isOpen">
    <app-filter
      (enterEvent)="presentfilter($event)"
      (filtersEvent)="setFilters($event)"
      [filters]="filters"
    ></app-filter>
  </div>
</div>
